<template>
  <div>
    <el-dialog
      v-if="dialogFormVisible"
      :title="'绑定新券'"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      @close="handleClose('ruleForm')"
    >
      <el-form ref="ruleForm" :model="peopleForm" :rules="peopleRules" label-width="100px">
        <el-form-item label="券号" :label-width="formLabelWidth" prop="cardNumber">
          <el-col :span="20">
            <el-input v-model="peopleForm.cardNumber" autocomplete="off" />
          </el-col>

        </el-form-item>
        <el-form-item label="密钥" :label-width="formLabelWidth" prop="secretKey">
          <el-col :span="20">
            <el-input v-model="peopleForm.secretKey" autocomplete="off" />
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="handlePeople('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { cdkeyBind } from '@/api/gift.js'
const defaultForm = {
  cardNumber: null,
  secretKey: null
}
export default {
  data() {
    return {
      peopleForm: Object.assign({}, defaultForm),
      dialogFormVisible: false,
      peopleRules: {
        cardNumber: [
          { required: true, message: '请输入券号', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        secretKey: [
          { required: true, message: '请输入密钥', trigger: 'blur' },
          { min: 1, max: 64, message: '请输入正确密钥', trigger: 'blur' }
        ]
      },
      formLabelWidth: '140px'
    }
  },
  created() {},
  mounted() {},
  methods: {
    show() {
      this.dialogFormVisible = true
    },
    // 取消
    handleClose(formName) {
      this.peopleForm = Object.assign({}, defaultForm)// 清空表单数据
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
      this.$refs[formName].clearValidate()
    },
    // 确认
    handlePeople(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            cardNumber: this.peopleForm.cardNumber,
            secretKey: this.peopleForm.secretKey
          }
          cdkeyBind(params).then(res => {
            if (res.code === 200) {
              this.$message.success('绑定成功')
              this.peopleForm = Object.assign({}, defaultForm)// 清空表单数据
              this.dialogFormVisible = false
              this.$refs[formName].clearValidate()
              this.$emit('refreshList')
            }
          })
        }
      })
    }
  }
}
</script>
